module.exports = __webpack_public_path__ + "static/media/news2.5251b4ed.jpg";